import { BaseApiResponse, SpiritoryWebEndpoints } from '@/types/api/api-v2';

import { spiritoryWebApi } from '@/lib/axios/spiritoryWebApi';
import { BlogPost } from '@/types/Blog';

export default async function getAllBlogPosts(locale: string) {
  try {
    const {
      data: { data },
    } = await spiritoryWebApi.get<BaseApiResponse<BlogPost[]>>(
      `/blog/all?locale=${locale}` as SpiritoryWebEndpoints
    );

    return data;
  } catch (err) {
    throw err;
  }
}
